
import Car from "../../../assets/outline/Car.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CarIcon({ className, dataTestid = "CarIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Car data-testid={dataTestid} className={classes} {...rest} />
  );
}
